import React from 'react';
import PropTypes from 'prop-types';

const MultiSearchTerms = ({ searchTerms }) => (
  <div className="hd-search__multiSearch__dropdown--termsWrapper">
    <ul className="hd-search__multiSearch__dropdown--termsList">
      {searchTerms && searchTerms.map((term, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className="hd-search__multiSearch__dropdown--termsListItem" key={index}>
          <a
            href={`/webshop/getNextMultiSearchProducts.do?nowShowing=${term}&multiIndex=0&type=multi&searchPageIndex=0`}
            className="hd-search__multiSearch__dropdown--termsListItemLink"
          >
            {term}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

MultiSearchTerms.propTypes = {
  searchTerms: PropTypes.arrayOf(PropTypes.string),
};

export default MultiSearchTerms;
